import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconFigma12 from './IconFigma12';
import IconFigma16 from './IconFigma16';
import IconFigma20 from './IconFigma20';
import IconFigma24 from './IconFigma24';
import IconFigma32 from './IconFigma32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconFigma = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconFigma12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconFigma16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconFigma20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconFigma24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconFigma32 {...props} />}
        </span>
    );
};
IconFigma.displayName = 'FondueIconFigma';

export default memo(IconFigma);
